export var ItemSignatureValidationResult;
(function (ItemSignatureValidationResult) {
    ItemSignatureValidationResult["NotApplicable"] = "NotApplicable";
    ItemSignatureValidationResult["Trusted"] = "Trusted";
    ItemSignatureValidationResult["SignedWithNonCurrentKey"] = "SignedWithNonCurrentKey";
    ItemSignatureValidationResult["NotTrusted"] = "NotTrusted";
})(ItemSignatureValidationResult || (ItemSignatureValidationResult = {}));
